import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import errRobotIMG from "../../assets/img/errRobot.png";
import {useNavigate} from "react-router-dom";
import {NetworkStatusContext} from "../../services/NetworkStatusContext";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function ErrStatusPg({ status }) {

    const { isOffline } = useContext(NetworkStatusContext);
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [theme] = useTheme();

    if (!isOffline) {
        return null; // 네트워크가 복구되면 페이지를 렌더링하지 않음
    }

    const getErrMessage = () => {
        switch (status) {
            case 401:
            case 402:
            case 403:
                return t('statusErr401');
            case 404:
                return t('statusErr404');
            case 500:
                return t('statusErr500');
            case 501:
                return t('statusErr501');
            case 502:
            case 503:
                return t('statusErr502');
            default:
                return t('statusErrEtc');
        }
    };

    const mainRefresh = () => {
        window.location.reload(); // 새로고침으로 홈으로 돌아가기
    };

    return (
        <div className="up-scope up-page" data-theme={theme} style={{minHeight: "100vh"}}>
            <div className="up-result-wrap" style={{flexDirection: "column"}}>
                <div className="up-result">
                    <img style={{width: "140px", height: "auto", opacity: "0.9"}} alt="errImage" src={errRobotIMG}/>
                    <p className="up-result-title" style={{fontSize: "20px"}}>{t('networkErr1')}</p>
                    <p className="up-result-sub" style={{fontSize: "15px"}}>{t(`networkErr2`)}</p>
                    <p className="up-result-sub" style={{fontSize: "15px", marginTop: "2px"}}>{t(`statusErrMsg`)}</p>
                    <div className="up-btn-row" style={{justifyContent: "center", marginTop: "26px"}}>
                        <button className="up-btn-primary" style={{height: "46px", fontSize: "15px", maxWidth: "200px", margin: "0 auto"}}
                                onClick={mainRefresh}>Back To Home
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErrStatusPg
